export var FuturesAccountTypes;
(function (FuturesAccountTypes) {
    FuturesAccountTypes["ISOLATED_MARGIN"] = "isolated_margin";
    FuturesAccountTypes["CROSS_MARGIN"] = "cross_margin";
})(FuturesAccountTypes || (FuturesAccountTypes = {}));
